import { AnalyticsServices } from './analytics-services';
import * as SellerPresetsActions from '../store/seller/presets/seller.presets.actions';
import * as SellerActions from '../store/seller/seller.actions';
import * as ShipmentActions from '../store/shipments/shipments.actions';
import * as ShipmentsFilteringActions from '../store/shipments/filtering/shipments.filtering.actions';
import * as ShipmentsDetailsActions from '../store/shipments/shipment-details/shipments.details.actions';
import * as ShipmentsNavActions from '../store/shipments/nav/shipments.nav.actions';
import * as ShipmentsSelectedShipmentsActions from '../store/shipments/selected-shipments/shipments.selected-shipments.actions';
import * as ShipmentsGridHeaderActions from '../store/shipments/grid/shipments.grid.header.actions';
import * as ShipmentsGridActions from '../store/shipments/grid/shipments.grid.actions';
import * as BulkErrorsAndWarningsActions from '../store/bulk-errors-and-warnings/bulk-errors-and-warnings.actions';
import * as BulkPrintActions from '../store/bulk/print/bulk.print.actions';
import * as BulkPurchaseActions from '../store/bulk/purchase/bulk.purchase.actions';
import * as PrintSettingsActions from '../store/print-settings/print-settings.actions';
import * as PrintingActions from '../store/printing/print.actions';
import * as TagActions from '../store/tags/tags.actions';
import * as SSConnectActions from '../store/shipstation-connect/ss-connect.actions';
import * as HoldUntilActions from '../store/hold-until/hold-until.actions';
import * as OrdersActions from '../store/orders/orders.actions';
import * as OrdersSelectedOrdersActions from '../store/orders/selected-orders/orders.selected-orders.actions';
import * as OrderDetailsActions from '../store/orders/order-details/orders.details.actions';
import * as OrdersFilteringActions from '../store/orders/filtering/orders.filtering.actions';
import * as CSWActions from '../store/csw/csw.actions';
import * as EditOrderActions from '../store/orders/edit-order/edit.order.actions';
import * as OrdersGridHeaderActions from '../store/orders/grid/orders.grid.header.actions';
import * as OrdersGridActions from '../store/orders/grid/orders.grid.actions';
import * as PostagePurchaseActions from '../store/postage-purchase/postage-purchase.actions';
import * as LabelActions from '../store/labels/labels.actions';
import * as BatchesNavActions from '../store/batches/nav/batches.nav.actions';
import * as BatchesActions from '../store/batches/batches.actions';
import * as BatchesGridActions from '../store/batches/grid/batches.grid.actions';
import * as BatchDetailActions from '../store/batches/details/batch.details.actions';
import * as BatchNoteActions from '../store/batches/notes/batch-note.actions';
import * as AddressActions from '../address/actions';
import * as CustomerCreateLabelActions from '../store/customers/create-label/customers.create-label.actions';
import * as CreateLabelActions from '../store/create-label-content/create-label-content.actions';
import * as ProductActions from '../store/products/products.actions';
import * as ScanToPrintActions from '../store/scan-to-print/scan-to-print.actions';
import * as ScanToPrintPurchaseActions from '../store/scan-to-print/s2p-purchase-and-print.actions';
import * as ScanToVerifyActions from '../scan/verify/store/scan-to-verify.actions';

import {
  STAMPS_SMS_PROMPT,
  STAMPS_SMS_REQUEST_CODE,
  STAMPS_SMS_RESEND_CODE,
  STAMPS_SMS_VERIFY_CODE_WRONG_CODE,
  STAMPS_SMS_VERIFY_CODE_SUCCESS,
  STAMPS_SMS_VERIFY_CODE_FAILURE_CONTACT_STAMPS,
} from '../components/phone-verify/analytics-event-strings';
import { V3_REFRESH_NOTIFICATION_SENT } from '../refresh-notification/constants';
import {
  V3_OPT_OUT_WITHOUT_FEEDBACK,
  V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE,
  V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS,
} from '../store/v3-opt-out/v3-opt-out.actions';

const actionWhitelist = [
  SellerPresetsActions.HOTKEY_APPLY_PRESET_REQUEST,
  SellerActions.REFRESH_STORE_REQUEST,
  SellerActions.REFRESH_ALL_STORES_REQUEST,
  SellerActions.PROMPT_SHIPSTATION_DHL_TERMS_AND_CONDITIONS,
  SellerActions.ACCEPT_DHL_WALLET_TERMS_REQUEST,
  SellerActions.ACCEPT_DHL_WALLET_TERMS_SUCCESS,
  SellerActions.ACCEPT_DHL_WALLET_TERMS_FAILURE,
  ShipmentActions.GET_SHIPMENTS_REQUEST,
  ShipmentActions.GET_SILENT_SHIPMENTS_REQUEST,
  ShipmentActions.GET_SHIPMENTS_SUCCESS,
  ShipmentsFilteringActions.SHIPMENTS_CHANGE_FILTERVIEW_PROP,
  ShipmentsFilteringActions.SHIPMENTS_AUTOSWITCH_FILTERVIEW_CUSTOM,
  ShipmentsFilteringActions.SHIPMENTS_SWITCH_FILTERVIEW,
  ShipmentsFilteringActions.SHIPMENTS_SAVE_NEW_FILTERVIEW_REQUEST,
  ShipmentsDetailsActions.SHIPMENT_DETAILS_MODAL_OPEN,
  ShipmentsDetailsActions.SHIPMENT_DETAILS_MODAL_CLOSED,
  ShipmentsDetailsActions.PRINT_PREVIEW,
  ShipmentsDetailsActions.SHIPMENT_DETAILS_GO_TO_ROUTE,
  ShipmentsDetailsActions.SHIPMENT_NOTIFY_MARKETPLACE_REQUEST,
  ShipmentsNavActions.SHIPMENTS_CHANGE_VIEW,
  ShipmentsNavActions.SHIPMENTS_SEARCH,
  ShipmentsSelectedShipmentsActions.SET_SELECTED_SHIPMENTS,
  ShipmentsGridHeaderActions.SHIPMENTS_GRID_SEND_SHIPMENT_NOTIFICATION,
  ShipmentsGridActions.SHIPMENT_GRID_CHANGE_COLUMNS,
  ShipmentsGridActions.SHIPMENT_GRID_CHANGE_ORDERBY,
  ShipmentsGridActions.SHIPMENT_GRID_MANAGE_COLUMNS,
  ShipmentsGridActions.PRINT_SHIPMENT_GRID_PACKING_SLIPS,
  ShipmentsGridActions.PRINT_SHIPMENT_GRID_LABELS,
  BulkErrorsAndWarningsActions.OPEN_BULK_ERRORS_AND_WARNINGS_MODAL,
  BulkErrorsAndWarningsActions.REMOVE_ITEM_FROM_SELECTION,
  BulkPrintActions.BULK_PRINT_START,
  BulkPrintActions.BULK_PRINT_END,
  BulkPurchaseActions.BULK_PURCHASE_START,
  BulkPurchaseActions.BULK_PURCHASE_END,
  PrintSettingsActions.RECEIVE_V2_PRINT_SETTINGS,
  PrintingActions.PRINT_PACKING_SLIP,
  PrintingActions.PRINT_LABEL,
  PrintingActions.PRINT_PICK_LIST,
  PrintingActions.PRINT_MODAL_OPEN,
  PrintingActions.DOCUMENT_DOWNLOAD_STARTED,
  PrintingActions.MARK_LABEL_PRINTED,
  PrintingActions.MARK_LABEL_PRINTED_FAILURE,
  PrintingActions.MARK_PACKING_SLIP_PRINTED,
  PrintingActions.MARK_PACKING_SLIP_PRINTED_FAILURE,
  ProductActions.CREATE_PRODUCT,
  ProductActions.GET_PRODUCT_DETAILS_SUCCESS,
  ProductActions.PRODUCT_DETAILS_MODAL_OPEN,
  ProductActions.UPDATE_PRODUCT,
  ProductActions.UPDATE_PRODUCT_FAILURE,
  ProductActions.UPDATE_PRODUCT_SUCCESS,
  ScanToPrintActions.SCAN_SETUP_CSW,
  ScanToPrintActions.SET_SCAN_HEADER_FOCUS,
  ScanToPrintActions.SET_SCAN_SEARCH_VALUE,
  ScanToPrintPurchaseActions.CREATE_LABEL_FOR_SCAN_TO_PRINT,
  ScanToPrintPurchaseActions.PRINT_SCAN_TO_PRINT_LABEL,
  ScanToVerifyActions.SET_VERIFICATION_STATUS_FAILURE,
  ScanToVerifyActions.SET_VERIFICATION_STATUS_SUCCESS,
  TagActions.MANAGE_TAGS,
  SSConnectActions.SET_DEFAULT_SCALE,
  SSConnectActions.PRINT_DOCUMENT_REQUEST,
  HoldUntilActions.LAUNCH_HOLD_UNTIL_MODAL,
  HoldUntilActions.HOLD_UNTIL,
  OrdersActions.ADD_TAGS_TO_FULFILLMENT_PLANS,
  OrdersActions.REMOVE_TAGS_FROM_FULFILLMENT_PLANS,
  OrdersActions.CREATE_ORDER_REQUEST,
  OrdersActions.CREATE_ORDER_SUCCESS,
  OrdersActions.CREATE_ORDER_FAILURE,
  OrdersActions.ORDERS_BULK_PRINT_PACKING_SLIPS,
  OrdersActions.ORDERS_PURCHASE_BULK_LABELS,
  OrdersActions.GET_ORDERS_REQUEST,
  OrdersActions.GET_SILENT_ORDERS_REQUEST,
  OrdersActions.GET_ORDERS_SUCCESS,
  OrdersSelectedOrdersActions.SET_SELECTED_ORDERS,
  OrderDetailsActions.ORDER_DETAILS_MODAL_OPENED,
  OrderDetailsActions.MARK_PAID,
  OrdersFilteringActions.ORDERS_SWITCH_FILTERVIEW,
  OrdersFilteringActions.ORDERS_SAVE_NEW_FILTERVIEW_REQUEST,
  CSWActions.CSW_UPDATE_SHIPMENT_CONFIGURATION,
  CSWActions.CSW_UPDATE_SHIPMENT_CONFIGURATION_OPTIONS,
  CSWActions.CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES,
  CSWActions.CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES_FROM_PRESET,
  CSWActions.CSW_CREATE_LABEL,
  CSWActions.CSW_CREATE_LABEL_SUCCESS,
  CSWActions.CSW_CREATE_LABEL_FAILURE,
  CSWActions.CSW_CHANGE_INSURED_VALUE,
  CSWActions.CSW_UPDATE_SERVICE_AND_OTHER_SHIPPING_OPTIONS,
  CSWActions.CSW_CREATE_TEST_LABEL,
  CSWActions.CSW_CREATE_TEST_LABEL_SUCCESS,
  EditOrderActions.NEW_ORDER_MODAL_OPEN,
  EditOrderActions.NEW_ORDER_MODAL_CLOSED,
  OrdersGridHeaderActions.ORDER_GRID_VALIDATE_ADDRESS,
  OrdersGridHeaderActions.OPEN_ADD_SALES_ORDER_TO_BATCH_FROM_ORDERS_GRID,
  OrdersGridActions.ORDER_GRID_CHANGE_COLUMNS,
  OrdersGridActions.ORDER_GRID_CHANGE_ORDERBY,
  OrdersGridActions.ORDER_GRID_CHANGE_PAGE,
  OrdersGridActions.ORDER_GRID_TOGGLE_SIDEBAR_VISIBILITY,
  OrdersGridActions.ORDER_GRID_MANAGE_COLUMNS,
  PostagePurchaseActions.POSTAGE_AND_INSURANCE_PURCHASE_REQUEST,
  LabelActions.LAUNCH_VOID_MODAL,
  LabelActions.VOID_LABELS,
  BatchesActions.SAVE_BATCHES_REQUEST,
  BatchesNavActions.TOGGLE_BATCH_NAV_MENU,
  BatchesGridActions.ARCHIVE_BATCHES_REQUEST,
  BatchesGridActions.VALIDATE_BATCHES_ADDRESSES_REQUEST,
  BatchesGridActions.UPDATE_BATCH_GRID_SORTING,
  BatchDetailActions.REMOVE_FULFILLMENT_PLANS_FROM_BATCH,
  BatchNoteActions.SAVE_OR_EDIT_BATCH_NOTE_REQUEST,
  AddressActions.LOG_PASTE_ADDRESS_USAGE,
  STAMPS_SMS_PROMPT,
  STAMPS_SMS_REQUEST_CODE,
  STAMPS_SMS_RESEND_CODE,
  STAMPS_SMS_VERIFY_CODE_WRONG_CODE,
  STAMPS_SMS_VERIFY_CODE_SUCCESS,
  STAMPS_SMS_VERIFY_CODE_FAILURE_CONTACT_STAMPS,
  CustomerCreateLabelActions.LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL,
  CreateLabelActions.CREATE_LABEL_ACTION,
  V3_REFRESH_NOTIFICATION_SENT,
  V3_OPT_OUT_WITHOUT_FEEDBACK,
  V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE,
  V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS,
];

class AnalyticsServiceClass {
  constructor() {
    this.initialized = false;
  }

  identifyUser(userId, sellerId, userInfo, sellerInfo) {
    if (this.initialized) {
      return;
    }
    AnalyticsServices.forEach((service) => service.identifyUser(userId, sellerId, userInfo, sellerInfo));
    this.initialized = true;
  }

  trackPage(pageName, metadata) {
    if (!this.initialized) {
      return;
    }

    AnalyticsServices.forEach((service) => service.trackPage(pageName, metadata));
  }

  trackEvent(actionName, params, metadata) {
    if (!this.initialized) {
      return;
    }

    if (actionWhitelist.indexOf(actionName) === -1) {
      return;
    }
    AnalyticsServices.forEach((service) => service.trackEvent(actionName, params, metadata));
  }

  trackManualEvent(eventName, params, metadata) {
    if (!this.initialized) {
      return;
    }

    AnalyticsServices.forEach((service) => service.trackEvent(eventName, params, metadata));
  }
}

export const AnalyticsService = new AnalyticsServiceClass();
